<script setup>
import { ref, computed } from 'vue';
import { useTranslaterStore } from '@/stores/translater'

const emit = defineEmits(['close'])

const translaterStore = useTranslaterStore()

const isShow = ref(false)
const events = ref(null)
const dateStart = ref(null)
const dateStop = ref(null)

const getTranslate  = computed(() => translaterStore.getTranslate)

function show(carEvents) {

    isShow.value = true

    events.value = carEvents.list.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
    dateStart.value = new Date(carEvents.dateStart * 1000).toLocaleString()
    dateStop.value = new Date(carEvents.dateStop * 1000).toLocaleString()
}

function close() {
    isShow.value = false

    events.value = null
    dateStart.value = null
    dateStop.value = null

    emit('close')
}

function formatEventDate(date) {
    return date.split(',')
}

defineExpose({
    show, 
    close
})
</script>

<template>
    <div 
        class="uta-car-map__list d-flex flex-column"
        :class="{ show: isShow }"
    >
        <div v-if="isShow" class="list-header position-relative">
            <div>
                <h5 class="list-title">{{ getTranslate.EVENTS_TRIP_TRACKS }}</h5>
                <p class="list-date">{{ formatEventDate(dateStart)[0] }} - {{ formatEventDate(dateStop)[0] }}</p>
            </div>
            <button 
                type="button" 
                class="btn-close list-close"
                @click="close"
            ></button>
        </div>
        <div v-if="isShow" class="list-body flex-fill">
            <div>
                <ul class="events p-0 m-0">
                    <li class="events-item d-flex" v-for="(event, idx) in events" :key="idx">
                        <div class="me-3">
                            <div class="events__date">{{ formatEventDate(new Date(event.createdAt / 1000).toLocaleString())[0] }}</div>
                            <div class="events__time">{{ formatEventDate(new Date(event.createdAt / 1000).toLocaleString())[1] }}</div>
                        </div>
                        <div class="events__title">{{ getTranslate['EVENT_' + event.eventType.toUpperCase()] }}</div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
@import '@/assets/styles/scss/components/car/car-map-list';
</style>